<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line clickable" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBackList()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-line--right">
        <div class="ir-btn th-btn-icon">
          <ng-container *ngFor="let session of point?.sessionIcons">
            <i
              *ngIf="session.user"
              (click)="navigateToSession(session)"
              [title]="session.user"
              class="material-icons session"
              [style.color]="session.color"
              style="padding-top: 0"
              [class.disabled]="session.away"
              [class.away]="session.away"
              [class.active]="!session.away"
              [class.highlight]="session.highlight && !session.away"
              >account_circle</i
            >
          </ng-container>
        </div>
        <div class="ir-btn th-btn-icon" *ngIf="!isConnection">
          <i class="material-icons">portable_wifi_off</i>
        </div>
        <div class="ir-btn th-btn-icon" *ngIf="point?.inspection?.isOffline">
          <i class="material-icons warning" *ngIf="point?.inspection?.updatedOffline">offline_pin</i>
          <i class="material-icons offline" *ngIf="!point?.inspection?.updatedOffline">offline_pin</i>
        </div>
        <div class="ir-btn th-btn-icon" *ngIf="!inspection?.isOffline && inspection?.isSynchronizing">
          <i class="material-icons offline">sync</i>
        </div>
        <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
          <i class="material-icons">search</i>
        </div>
        <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.edit', inspection]]" (click)="openMenu()">
          <i class="material-icons">more_vert</i>
        </div>
      </div>
    </div>
    <div class="ir-line-content" (click)="gotoPropertiesPage()">
      <span
        >{{ point?.name }} <strong>({{ point?.plugins?.length }})</strong></span
      >
    </div>
    <div class="ir-popup th-popup">
      <span
        ><strong>{{ point.inspection?.name }}</strong> {{ point.section ? '/' : ''
        }}<strong *ngIf="point.section">{{ point.section.name }}</strong> {{ point.folder ? '/' : ''
        }}<strong *ngIf="point.folder">{{ point.folder.name }}</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <point-detail
    [processing]="processing"
    [showHelp]="showHelp"
    [inspectionId]="inspectionId"
    [point]="point"
    (toggleUpdateStatus)="updateStatus($event)"
    (toggleCancel)="cancel()"
    [query]="query"
  ></point-detail>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>
<order-summaries
  #orderPlugins
  [title]="'points.order-plugins' | translate"
  (toggleSave)="savePluginsOrder($event)"
  (toggleCancel)="cancel()"
></order-summaries>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePoint($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'points.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #saveConfirm
  (confirmOutput)="saveChanges($event)"
  (modalClosed)="dontSaveChanges()"
  [title]="'common.save-confirmation' | translate"
  [message]="'points.save-changes' | translate"
  [danger]="true"
  [okButtonText]="'points.save-button' | translate"
  [cancelButtonText]="'points.dontsave-button' | translate"
></confirm>
